import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'manage.Companies' | translate }}</h1>
            <a class="btn add" ui-sref="authorized.manage.permissions.companies.add()">{{ 'manage.Add company' | translate }}</a>
        </div>
        <div class="search02 mt10 w100p" ng-if="vm.PrivilegeService.isSuperAdmin()">
            <input type="text"
                   placeholder="{{ 'company.Search by name' | translate }}"
                   ng-model="vm.filter.name"
                   ng-change="vm.onSearchChanged()">
        </div>
        <list-factory-empty ng-if="!vm.list.items.length" list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'company.Name' | translate }}</a></th>
                        <th>{{ 'company.Slug' | translate }}</th>
                        <th>{{ 'company.Active employees' | translate }}</th>
                        <th>{{ 'company.Skin' | translate }}</th>
                        <th>{{ 'company.Modules' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items track by item.id">
                        <td>
                            <a ui-sref="authorized.manage.permissions.companies.edit({ id: item.id })">{{ item.name }}</a>
                        </td>
                        <td>{{ item.slug }}</td>
                        <td>{{ item.userCount }}</td>
                        <td>{{ vm.COMPANY_SKIN_ENUM.LABELS[item.skin] }}</td>
                        <td>
                            <span uib-tooltip="{{ vm.lodash.join(vm.getEnabledModules(item), ', ') }}">{{ vm.getEnabledModules(item).length }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($timeout, $translate, lodash, DATATABLES, ListFactory, CompanyResource, COMPANY_SKIN_ENUM, PrivilegeService) {
        this.$timeout = $timeout;
        this.lodash = lodash;
        this.$translate = $translate;
        this.DATATABLES = DATATABLES;
        this.COMPANY_SKIN_ENUM = COMPANY_SKIN_ENUM;
        this.ListFactory = ListFactory;
        this.CompanyResource = CompanyResource;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.filter = {};
        this.searchPromise = null;
        this.list = this.ListFactory.createWithPagination(this.CompanyResource.query.bind(this.CompanyResource));
        this.list.fetch(this.filter);
    }

    onSearchChanged () {
        if (this.searchPromise) {
            this.$timeout.cancel(this.searchPromise);
        }
        this.searchPromise = this.$timeout(() => {
            // a narrowed result set has fewer pages, so start over from the first one
            this.list.pagination.currentPage = 1;
            this.list.fetch(this.filter);
        }, 300);
    }

    getEnabledModules (company) {
        const enabledModules = [];
        this.lodash.forEach(company, (value, property) => {
            if (value) {
                if (property === 'isFormModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Forms module enabled'));
                }
                else if (property === 'isFormEvaluationModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Forms 360 feedback module enabled'));
                }
                else if (property === 'isFormSurveyModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Forms survey module enabled'));
                }
                else if (property === 'isPerformanceReviewModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Performance review module enabled'));
                }
                else if (property === 'isLicencePointsModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Licence points module'));
                }
                else if (property === 'isScormCloudEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is scorm cloud enabled'));
                }
                else if (property === 'isOptionalCoursesModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is optional course module enabled'));
                }
                else if (property === 'isBudgetModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is budget module enabled'));
                }
                else if (property === 'isCompetencesModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is competences and skills module enabled'));
                }
                else if (property === 'isTrainingCompany') {
                    enabledModules.push(this.$translate.instant('company.Training company'));
                }
                else if (property === 'isWebinarModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is webinar module enabled'));
                }
                else if (property === 'isTasklistModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is tasklist module enabled'));
                }
                else if (property === 'isExternalParticipationModuleEnabled') {
                    enabledModules.push(this.$translate.instant('company.Is external participation module enabled'));
                }
            }
        });

        return enabledModules;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/companies/list/index.js